import { Box, Grid, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button } from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useGetList, useRecordContext } from 'react-admin';
import { useState } from 'react';

const Statistics = () => {
	const record = useRecordContext();
	const [viewMode, setViewMode] = useState<'chart' | 'table'>('chart');
	const { data: tags, isLoading: tagsLoading } = useGetList('tag/all', {
		pagination: { page: 1, perPage: 100 },
		sort: { field: 'name.he', order: 'ASC' },
	});
	
	const { data: members, isLoading: membersLoading } = useGetList('member', {
		pagination: { page: 1, perPage: 1000 },
		filter: { company: record?.id }
	});
	
	const chartData = tags?.map(tag => {
		const membersWithTag = members?.filter(member => member.tags?.includes(tag._id)) || [];
		return {
			name: tag?.short_name?.he || tag?.name?.he || 'Unnamed Tag',
			members: membersWithTag.length,
		};
	}) || [];

	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<Paper sx={{ p: 3 }}>
					<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
						<Typography variant="h6">
							תחומי עניין לפי מספר משתמשים
						</Typography>
						<Button 
							variant="contained" 
							onClick={() => setViewMode(viewMode === 'chart' ? 'table' : 'chart')}
						>
							{viewMode === 'chart' ? 'הצג טבלה' : 'הצג גרף'}
							
						</Button>
					</Box>
					{viewMode === 'chart' ? (
						<Box sx={{ width: '100%', height: 400 }}>
							<ResponsiveContainer>
								<BarChart
									data={chartData}
									margin={{
										top: 5,
										right: 30,
										left: 20,
										bottom: 5,
									}}
								>
									<CartesianGrid strokeDasharray="3 3" />
									<XAxis dataKey="name" />
									<YAxis />
									<Tooltip />
									<Legend />
									<Bar dataKey="members" fill="#8884d8" name="מספר משתמשים" />
								</BarChart>
							</ResponsiveContainer>
						</Box>
					) : (
						<TableContainer>
							<Table>
								<TableHead>
									<TableRow>
										<TableCell>תחום עניין</TableCell>
										<TableCell align="right">מספר משתמשים</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{chartData.map((row) => (
										<TableRow key={row.name}>
											<TableCell component="th" scope="row">
												{row.name}
											</TableCell>
											<TableCell align="right">{row.members}</TableCell>
										</TableRow>
									))}
								</TableBody>
							</Table>
						</TableContainer>
					)}
				</Paper>
			</Grid>
		</Grid>
	);
};

export default Statistics;
